var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-container",
        { staticClass: "mt-4 mb-4" },
        [
          _c(
            "div",
            { staticClass: "col-md-12 mt-4 d-flex align-items-start" },
            [
              _c("back-arrow", { attrs: { title: _vm.$t("Menu.my.alerts") } }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-auto",
                  attrs: { variant: "primary" },
                  on: { click: _vm.goToSearch }
                },
                [_vm._v(_vm._s(_vm.$t("saved.search.a.create")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c(
                "transition-group",
                {
                  attrs: {
                    appear: "",
                    name: "listCustomTransition",
                    tag: "div"
                  }
                },
                [
                  _c(
                    "div",
                    { key: "homePlaceHolder-draft", staticClass: "mt-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "other-annonces card-container row row-cards-annonces"
                        },
                        [
                          _c("PlaceholderCardAlerts", {
                            attrs: { isAnimated: true, isGradient: false }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAlerts", {
                            attrs: { isAnimated: true, isGradient: false }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAlerts", {
                            attrs: { isAnimated: true, isGradient: false }
                          }),
                          _vm._v(" "),
                          _c("PlaceholderCardAlerts", {
                            attrs: { isAnimated: true, isGradient: false }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "transition-group",
                { attrs: { name: "listCustomTransition" } },
                [
                  _vm.myAlerts.length > 0
                    ? _vm._l(_vm.myAlerts, function(alert, index) {
                        return _c(
                          "div",
                          {
                            key: index + "-alert",
                            staticClass: "mt-2 alert-container"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center alert-header"
                              },
                              [
                                _c(
                                  "h1",
                                  {
                                    staticClass: "page-subtitle cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.redirectToAlertAnnonce(
                                          alert.id,
                                          alert.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " + _vm._s(alert.name)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-icon", {
                                  staticClass: "delete-icon",
                                  attrs: { icon: "trash", variant: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteAlert(alert.id)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            alert.description
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-2 main-grey-medium-color alert-description"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "annonce.home.savedSearch.with.filters"
                                          )
                                        ) +
                                        " " +
                                        _vm._s(alert.description) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      })
                    : [
                        _c(
                          "div",
                          { key: "favorites-empty-list", staticClass: "mt-2" },
                          [
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "p-3" }, [
                                _c("img", {
                                  staticClass: "empty-state-img-home",
                                  attrs: {
                                    src: require("@/assets/images/b122/img-confused.png"),
                                    alt: "no result"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "empty-state-text" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "my.alerts.empty.state.description"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("delete-saved-search-modal", {
        attrs: {
          "selected-item": _vm.savedSearchId,
          "selected-item-name": _vm.savedSearchName,
          "begins-with-voyel": "",
          "item-to-string": "alerte",
          "the-article": "l'"
        },
        on: { didDeleteItem: _vm.didDeleteAlert }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-278ea61d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-278ea61d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyAlerts.vue
// module id = 3/u0
// module chunks = 0